import { useEffect, useRef } from "react";
import { Link } from "../../../router/LocaleLink";
import { useTranslation } from "react-i18next";
import { Paths } from "../../../router/paths";
import {
  trackAnnualDiscountPromoBarClicked,
  trackAnnualDiscountPromoBarShown,
} from "../../../analytics/amplitude";
import styles from "./AnnualDiscountBanner.module.css";

interface AnnualDiscountBannerProps {
  percent: number;
}

export const AnnualDiscountBanner = ({
  percent,
}: AnnualDiscountBannerProps) => {
  const { t } = useTranslation();
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    trackAnnualDiscountPromoBarShown();
  }, []);

  const handleCta = () => {
    trackAnnualDiscountPromoBarClicked();
  };

  return (
    <aside
      className={styles.bar}
      role="region"
      aria-label={t("pages.annualDiscountPromo.barAria", { percent })}
    >
      <p className={styles.copy}>
        <span className={styles.headline}>
          {t("pages.annualDiscountPromo.barHeadline", { percent })}
        </span>
        <span className={styles.sub}>
          {t("pages.annualDiscountPromo.barSub")}
        </span>
      </p>
      <Link to={Paths.SUBSCRIPTIONS} className={styles.cta} onClick={handleCta}>
        {t("pages.annualDiscountPromo.cta")}
      </Link>
    </aside>
  );
};
